import { Container, DottedBanner, SectionTitle } from '@sloyd/ui';
import { Json } from '../../types';
import { Wrapper } from './ContentDiscord.style';

export type ContentDiscordProps = {
  content: Json;
};

export function ContentDiscord(props: ContentDiscordProps) {
  const { content } = props;

  return (
    <Wrapper className='ContentDiscord-wrapper' data-testid='ContentDiscord-wrapper'>
      <SectionTitle gradient={{ from: '#36d1dc', to: '#5b86e5' }} title='🗨️ Discord'></SectionTitle>
      <Container>
        <DottedBanner content={content} />
      </Container>
    </Wrapper>
  );
}

export default ContentDiscord;
